import SomethingHappened from '@/components/SomethingHappened';

import styles from './ChartErrorState.module.scss';

export interface ChartErrorStateProps {
    /** The plot's height, so the card keeps its size when the chart fails. */
    height?: number | string;
    /** Offers Try again, so one failed chart does not need a page reload. */
    onRetry?: () => void;
    isRetrying?: boolean;
}

/** What a chart shows in place of its plot when its data failed to load. */
export default function ChartErrorState(props: ChartErrorStateProps) {
    const { height, onRetry, isRetrying } = props;

    return (
        <div className={styles.errorArea} style={{ height }}>
            <SomethingHappened onRetry={onRetry} isRetrying={isRetrying} />
        </div>
    );
}
